import { Zap, DollarSign, FileCheck, ShieldCheck } from "lucide-react";

const trustItems = [
  {
    icon: ShieldCheck,
    title: "Información Verificada",
    desc: "Cada guía es revisada con fuentes oficiales del DMV y publicaciones especializadas en seguros.",
  },
  {
    icon: Zap,
    title: "Certificado en 24 horas",
    desc: "Las aseguradoras que listamos envían el SR-22 electrónicamente al DMV de tu estado.",
  },
  {
    icon: DollarSign,
    title: "Comparativa Gratuita",
    desc: "Comparamos las principales aseguradoras para ayudarte a encontrar la mejor tarifa disponible.",
  },
  {
    icon: FileCheck,
    title: "Aceptado por el DMV",
    desc: "Solo incluimos aseguradoras autorizadas por el Departamento de Vehículos Motorizados.",
  },
];

export default function TrustBar() {
  return (
    <section
      className="py-7 md:py-9 border-b"
      style={{ background: "hsl(var(--card))", borderColor: "hsl(var(--border))" }}
    >
      <div className="container mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-5xl mx-auto">
          {trustItems.map(({ icon: Icon, title, desc }, i) => (
            <div
              key={title}
              className="flex flex-col items-center text-center gap-2 animate-fade-up"
              style={{ animationDelay: `${i * 0.08}s`, animationFillMode: "both" }}
            >
              <div
                className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
                style={{ background: "hsl(var(--primary) / 0.08)" }}
              >
                <Icon className="w-5 h-5" style={{ color: "hsl(var(--primary))" }} />
              </div>
              <h3 className="font-bold text-xs md:text-sm leading-tight" style={{ color: "hsl(var(--foreground))" }}>
                {title}
              </h3>
              <p className="text-xs leading-relaxed" style={{ color: "hsl(var(--muted-foreground))" }}>
                {desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
